import React, { useState } from "react";

const Select = ({
  className,
  defaultOption,
  name,
  onChange,
  items = [
    {
      value: "option1",
      name: "Option 1",
    },
    {
      value: "option2",
      name: "Option 2",
    },
    {
      value: "option3",
      name: "Option 3",
    },
  ],
  disabled = false,
  value,
  id = "select",
  placeholder = "",
}) => {
  const [selectedOption, setSelectedOption] = useState(
    defaultOption || items[0] === undefined ? "" : items[0].value
  );

  const handleSelectChange = (e) => {
    setSelectedOption(e.target.value);
    onChange(e);
  };

  React.useEffect(() => {
    if (value) {
      setSelectedOption(value);
    }
  }, [value]);
  return (
    <div className={`${className}`}>
      <select
        id={id}
        placeholder={placeholder}
        disabled={disabled}
        value={selectedOption}
        onChange={handleSelectChange}
        name={name}
        className={`w-full h-10 border-2 focus:outline-yellow-400 rounded-md p-1 ${className} ${
          disabled ? "cursor-not-allowed" : ""
        }`}
      >
        {defaultOption ? (
          <option value={defaultOption.value}>{defaultOption.name}</option>
        ) : (
          <></>
        )}
        {items &&
          items.map((data, key) => {
            return (
              <option value={data.value} key={key}>
                {data.name}
              </option>
            );
          })}
      </select>
      {/* {selectedOption && <p className="mt-2">You selected: {selectedOption}</p>} */}
    </div>
  );
};

export default Select;
